/* ITG: size guide drawer - open/close, tab switching, CM/IN unit conversion */
(function () {
  'use strict';

  if (window.customElements && window.customElements.get('size-guide-drawer')) {
    return;
  }

  var CM_PER_IN = 2.54;

  function convertCell(raw, sourceUnit, targetUnit) {
    if (sourceUnit === targetUnit) return raw;
    // ITG: parse a numeric value (allowing ranges like "82-86" or "82 - 86") and convert each number
    var numberRe = /-?\d+(?:\.\d+)?/g;
    var hasNumber = numberRe.test(raw);
    numberRe.lastIndex = 0;
    if (!hasNumber) return raw;
    return raw.replace(numberRe, function (match) {
      var n = parseFloat(match);
      if (isNaN(n)) return match;
      var converted;
      if (sourceUnit === 'cm' && targetUnit === 'in') {
        converted = n / CM_PER_IN;
      } else if (sourceUnit === 'in' && targetUnit === 'cm') {
        converted = n * CM_PER_IN;
      } else {
        return match;
      }
      // ITG: round to 1 decimal, trim trailing .0 for cleaner display
      var rounded = Math.round(converted * 10) / 10;
      return (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1));
    });
  }

  class SizeGuideDrawer extends HTMLElement {
    constructor() {
      super();
      this._onKeydown = this._onKeydown.bind(this);
      this._onClick = this._onClick.bind(this);
      this._sourceUnit = (this.getAttribute('data-source-unit') || 'cm').toLowerCase();
      this._currentUnit = this._sourceUnit;
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
      // ITG: stash the original values so we can toggle units without losing precision
      this.querySelectorAll('[data-sg-value]').forEach(function (cell) {
        if (!cell.hasAttribute('data-sg-original')) {
          cell.setAttribute('data-sg-original', cell.textContent.trim());
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('keydown', this._onKeydown);
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sg-drawer-open');
        document.addEventListener('keydown', this._onKeydown);
        const closeBtn = this.querySelector('.sg-drawer__close');
        if (closeBtn) closeBtn.focus();
      });
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sg-drawer-open');
      document.removeEventListener('keydown', this._onKeydown);
      setTimeout(() => { this.hidden = true; }, 350);
      if (this._opener && typeof this._opener.focus === 'function') {
        this._opener.focus();
      }
    }

    _onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
      }
    }

    _onClick(e) {
      const closeTrigger = e.target.closest('[data-sg-close]');
      if (closeTrigger) {
        e.preventDefault();
        this.close();
        return;
      }
      const tabBtn = e.target.closest('[data-sg-tab]');
      if (tabBtn) {
        this._activateTab(tabBtn.getAttribute('data-sg-tab'));
        return;
      }
      const toggleTrack = e.target.closest('[data-sg-toggle]');
      if (toggleTrack) {
        this._setUnit(this._currentUnit === 'cm' ? 'in' : 'cm');
        return;
      }
      const unitBtn = e.target.closest('[data-sg-unit]');
      if (unitBtn) {
        this._setUnit(unitBtn.getAttribute('data-sg-unit'));
      }
    }

    _activateTab(name) {
      this.querySelectorAll('[data-sg-tab]').forEach((btn) => {
        const active = btn.getAttribute('data-sg-tab') === name;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.querySelectorAll('[data-sg-panel]').forEach((panel) => {
        const active = panel.getAttribute('data-sg-panel') === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    _setUnit(unit) {
      var target = (unit || 'cm').toLowerCase();
      if (target !== 'cm' && target !== 'in') return;
      if (target === this._currentUnit) return;

      this.querySelectorAll('[data-sg-unit]').forEach((btn) => {
        var active = btn.getAttribute('data-sg-unit') === target;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.querySelectorAll('.sg-drawer__unit-switch').forEach(function (sw) {
        sw.setAttribute('data-active', target);
      });

      this.querySelectorAll('[data-sg-unit-label]').forEach(function (cell) {
        cell.textContent = target.toUpperCase();
      });

      var source = this._sourceUnit;
      this.querySelectorAll('[data-sg-value]').forEach(function (cell) {
        var original = cell.getAttribute('data-sg-original') || cell.textContent.trim();
        cell.textContent = convertCell(original, source, target);
      });

      this._currentUnit = target;
    }
  }

  customElements.define('size-guide-drawer', SizeGuideDrawer);

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-size-guide-open]');
    if (!trigger) return;
    e.preventDefault();
    const targetId = trigger.getAttribute('data-size-guide-open');
    const drawer = targetId ? document.getElementById(targetId) : document.querySelector('size-guide-drawer');
    if (!drawer) return;
    drawer._opener = trigger;
    drawer.open();
  });
})();
